import { IAuditTableRow, AuditTableState } from "./AuditEventsCheck";
import { Grid } from "@mui/material";
import { Theme } from "@mui/material/styles";

interface IAuditTableCellStateProps {
  row: IAuditTableRow;
}

export const AuditTableCellState = (props: IAuditTableCellStateProps): JSX.Element => {
  const { row } = props;
  const cellStyles = (theme: Theme): any => ({
    display: "inline-block",
    width: 80,
    height: 30,
    padding: "7px 0px 0px 0px",
    borderRadius: 3,
    color: "white",
    textAlign: "center",
    fontWeight: 700,
    fontSize: 14,
    backgroundColor: () => {
      switch (row.state) {
        case AuditTableState.NEW:
          return theme.palette.success.main;
        case AuditTableState.MODIFIED:
          return theme.palette.warning.main;
        case AuditTableState.DELETED:
          return theme.palette.error.main;
        case AuditTableState.ALL:
          return theme.palette.common.black;
      }
    },
  });
  return (
    <Grid container sx={(theme) => cellStyles(theme)}>
      {row.state}
    </Grid>
  );
};
